var _path, _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingfailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 181,
    viewBox: "0 0 196 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2209 0C57.4512 0 60.5287 1.24742 63.1182 3.17856C72.6502 10.2871 84.7598 14.5409 97.9404 14.541C111.121 14.541 123.231 10.2873 132.764 3.17858C135.353 1.24743 138.431 0 141.661 0H182.794C190.022 0 195.881 5.85918 195.881 13.0868V167.222C195.881 174.449 190.022 180.309 182.794 180.309H141.661C138.431 180.309 135.353 179.061 132.764 177.13C123.231 170.021 111.121 165.768 97.9404 165.768C84.7598 165.768 72.6502 170.021 63.1182 177.13C60.5287 179.061 57.4512 180.309 54.2209 180.309H13.0868C5.85918 180.309 0 174.449 0 167.222V13.0868C0 5.85917 5.85918 0 13.0868 0H54.2209Z",
    fill: "#FAF2F2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.2614,
    cy: 90.3866,
    rx: 48.32,
    ry: 47.7318,
    fill: "#FF3B30",
    fillOpacity: 0.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.528,
    cy: 90.65,
    rx: 35.2389,
    ry: 34.8099,
    fill: "#FF3B30",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2985_27548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.835 79.8394C112.678 78.9963 112.678 77.6294 111.835 76.7863C110.992 75.9432 109.625 75.9432 108.782 76.7863L100.041 85.5266C99.0267 86.5413 97.3815 86.5413 96.3668 85.5266L87.6265 76.7863C86.7834 75.9432 85.4165 75.9432 84.5734 76.7863C83.7303 77.6294 83.7303 78.9963 84.5734 79.8394L93.3137 88.5796C94.3284 89.5944 94.3284 91.2396 93.3137 92.2543L84.5734 100.995C83.7303 101.838 83.7303 103.205 84.5734 104.048C85.4165 104.891 86.7834 104.891 87.6265 104.048L96.3668 95.3074C97.3815 94.2927 99.0267 94.2927 100.041 95.3074L108.782 104.048C109.625 104.891 110.992 104.891 111.835 104.048C112.678 103.205 112.678 101.838 111.835 100.995L103.095 92.2543C102.08 91.2396 102.08 89.5944 103.095 88.5796L111.835 79.8394Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2985_27548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.9676,
    height: 51.9676,
    fill: "white",
    transform: "translate(72.2227 64.4336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingfailed);
export default __webpack_public_path__ + "static/media/bookingfailed.2de182a59d537dc326d1365ef4482a06.svg";
export { ForwardRef as ReactComponent };